// extracted by mini-css-extract-plugin
export default {"wrapper":"zw-z","response":"Aw-z","error":"Bw-z","disabled":"Cw-z","buttons":"Dw-z","feedbackQuestionSection":"Ew-z","yesNoWrapper":"Fw-z"};